module.exports = __webpack_public_path__ + "static/img/pipeline-wall-hole_256.ce9e720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pipeline-wall-hole_256.png
// module id = 3VPH
// module chunks = 0